export default "__VITE_ASSET__BF1kNvHw__"